<template>
  <div class="head-page">
    <Header :title="$t('staking.title')" :icontype="2" :iconkey="'todo-list-o'" :iconurl="'staking-list'" />
    <div class="head-page-overflow">
        <StakingItem :item="data" v-for="(data,index) in data" :key="index" />
    </div>
  </div>
</template>
  
  <script>
import Header from "@/components/Header";
import { StakingItem } from './components/index'
export default {
  name: "MyStaking",
  components: { Header, StakingItem },
  data(){
    return {
      data:null
    }
  },
  mounted(){
    this.getStakingProjects()
  },
  methods:{
    async getStakingProjects(){
      await this.$http({
        method: "post",
        url: "getStakingProjects"
      }).then((res) => {
        this.data = res.data.list;
      }); 
    }
  }
};
</script>

<style>
</style>
